import React from "react";
import {
	Edit,
	SimpleForm,
	SelectInput,
	TextField,
	TextInput,
	Toolbar,
	SaveButton,
	FormDataConsumer,
	required,
} from "react-admin";

const CustomToolbar = (props) => (
	<Toolbar {...props}>
		<SaveButton />
	</Toolbar>
);

const PostEdit = ({ permissions, ...props }) => {
	return (
		<Edit title="Post" {...props}>
			<SimpleForm redirect="list" toolbar={<CustomToolbar />}>
				<TextField source="user.name" label="User Name"  />
				<TextField source="user.email" label="User Email"  />
				<TextField source="platform" label="Platform"  />
				<TextField source="url" label="URL"  />
				<TextField source="description" label="Description"  />
				<SelectInput source="status" label="Status" choices={[
					{ id: 'Pending', name: 'Pending' },
					{ id: 'Approved', name: 'Approved' },
					{ id: 'Rejected', name: 'Rejected' },
				]} />
				<FormDataConsumer>
					{({ formData, ...rest }) => {
						const validateRejectReason = (value, allValues, props) => {
							if (allValues && allValues.status === 'Rejected') {
								return required()(value, allValues, props);
							}
							return undefined;
						};
						return (
							<TextInput 
								source="reject_reason" 
								label="Reject Reason"
								validate={validateRejectReason}
								{...rest}
							/>
						);
					}}
				</FormDataConsumer>
				<TextField source="createdAt" label="Created Date"  />
			</SimpleForm>
		</Edit>
	);
};

export default PostEdit;
